import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { relativeTimeAgo } from "@sp-crm/core";
import React from "react";
import { isoDateStringToHumanReadable } from "../../util/date/locale-date-format";
import { ReceivedMessage } from "./received-message-detail";
import { formatContactDisplay } from "./unified-message";

interface Props {
    message: ReceivedMessage;
    onCollapse: () => void;
}

export const ReceivedMessageInlineDetail: React.FC<Props> = props => {
    const { message, onCollapse } = props;

    const fromDisplay = formatContactDisplay(message.from?.name, message.from?.email);

    const toRecipients = message.to
        .map(r => formatContactDisplay(r.contact.name, r.contact.email))
        .join(", ");

    const timestamp = new Date(message.receivedTimestamp);

    return (
        <div className="border-b border-gray-200">
            <div
                className="flex items-start gap-3 px-3 py-2 pl-8 hover:bg-gray-50 cursor-pointer"
                onClick={onCollapse}>
                <ChevronRightIcon
                    className="h-3 w-3 text-gray-400 flex-shrink-0 mt-1 rotate-90"
                    aria-hidden="true"
                />
                <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                        <span className="font-medium text-sm text-gray-900">
                            {fromDisplay}
                        </span>
                        <span className="text-xs text-gray-500 flex-shrink-0">
                            {relativeTimeAgo(timestamp)}
                        </span>
                    </div>
                    <div className="text-sm text-gray-500">
                        <span className="text-gray-400">To:</span> {toRecipients}
                    </div>
                    <div className="text-sm text-gray-500">
                        <span className="text-gray-400">Received:</span>{" "}
                        {isoDateStringToHumanReadable(message.receivedTimestamp)}
                    </div>
                </div>
            </div>
            <div className="pt-2 pb-3 pl-14 pr-4">
                {message.bodyPreview && (
                    <div className="text-sm text-gray-700 whitespace-pre-wrap">
                        {message.bodyPreview}
                    </div>
                )}
            </div>
        </div>
    );
};
